const actions = {
  SEARCH_OFFER_REQUEST: 'SEARCH_OFFER_REQUEST',
  SEARCH_OFFER_FAILURE: 'SEARCH_OFFER_FAILURE',
  SEARCH_OFFER_SUCCESS: 'SEARCH_OFFER_SUCCESS',
}

export default actions
